<script lang="ts">
  import { page } from '$app/stores';
  import { setContext } from 'svelte';
  import relativeTimePlugin from 'dayjs/plugin/relativeTime';
  import utcPlugin from 'dayjs/plugin/utc';
  import localizedFormatPLugin from 'dayjs/plugin/localizedFormat';
  import customParseFormat from 'dayjs/plugin/customParseFormat';
  import dayjs from 'dayjs';
  import 'bootstrap/dist/css/bootstrap.css';
  import '../global.css';
  import { onMount } from 'svelte';
  import type { LayoutData } from './$types';
  import * as Sentry from '@sentry/sveltekit';
  import { afterNavigate, invalidateAll } from '$app/navigation';
  import { defineAbilityFor } from '$lib/ability';

  dayjs.extend(relativeTimePlugin);
  dayjs.extend(utcPlugin);
  dayjs.extend(localizedFormatPLugin);
  dayjs.extend(customParseFormat);

  export let data: LayoutData;

  afterNavigate(() => {
    /**
     * Because authentication logic is implemented in SvelteKit server hook,
     * when redirect happens the page data is not updated, thus client still thinks user is logged in.
     * This uses a second cookie to check if user is actually logged in, otherwise invalidates all current load functions.
     */
    if (!document?.cookie.includes('isLoggedIn') && $page.data.authUser) {
      invalidateAll();
    }
  });

  setContext('global', {
    isAdmin: data.authUser?.isAdmin,
    userAbility: defineAbilityFor($page.data.authUser),
    userSettings: $page.data.authUser?.settings ?? {},
    currencyExchangeRates: $page.data?.currencyExchangeRates ?? {}
  });

  if (data.crispChat) {
    onMount(async () => {
      let Crisp;

      try {
        Crisp = (await import('crisp-sdk-web')).Crisp;
        window.Crisp = Crisp;
      } catch (err) {
        Sentry.captureException(err);
        return;
      }

      Crisp.configure('f33c5d82-ac4a-4506-8127-b1505653ce90');

      if (data.authUser) {
        const user = data.authUser;

        Crisp.user.setEmail(user.email);
        Crisp.user.setNickname(user.fullName);
        Crisp.user.setCompany(user.company.name, {});

        Crisp.session.setData({
          userId: user.id,
          emailConfirmed: user.emailConfirmed
        });
      }
    });
  }

  afterNavigate(() => {
    document.getElementById('page')?.scrollTo(0, 0);
  });
</script>

<svelte:head>
  <title>ITAD Auctions</title>
</svelte:head>

{#if data.authUser && data.usetiful}
  {@html `
    <script>
      (function (w, d, s) {
        var a = d.getElementsByTagName('head')[0];
        var r = d.createElement('script');
        r.async = 1;
        r.src = s;
        r.setAttribute('id', 'usetifulScript');
        r.dataset.token = 'fe18ab7b794778831f27ad801c77a7b4';
        a.appendChild(r);
      })(window, document, 'https://www.usetiful.com/dist/usetiful.js');
    </script>
  `}
{/if}

<slot />

<slot name="scripts" />

<style>
  :global(html) {
    min-height: 100%;
  }

  :global(body) {
    display: flex;
    flex-direction: column;
    height: unset !important;
    min-height: 100vh;
    z-index: 1;
  }
</style>
